const checkHttpResponseCode = (code) => {
  return code >= 200 && code < 300;
};

export default checkHttpResponseCode;
